import { getEnvType } from "../Networking/NetworkingUtils"

export function blobDomain() {
    if (getEnvType() === "prod") {
        return 'https://drstorageprod-fd-hcezh5aya8brbwg6.a01.azurefd.net/'
    }else if (getEnvType() === "qa") {
        return 'https://bbversestorageqa-f8dkbkcudfadauge.z01.azurefd.net/'
    }
    return 'https://bbverseblobdev-hmgaeqaud0ekgrcs.z01.azurefd.net/'
}

export function blobNoCacheDomain() {
    if (getEnvType() === "prod") {
        return 'https://drstorageprod.blob.core.windows.net/'
    } else if (getEnvType() === "qa") {
        return 'https://bbversestorageqa.blob.core.windows.net/'
    }
    return "https://bbverseblobdev.blob.core.windows.net/"
}

export function blobSAS() {
    if (getEnvType() === "prod") {
        return 'sv=2024-11-04&ss=b&srt=o&sp=r&se=2026-12-31T14:23:05Z&st=2025-08-14T06:08:05Z&spr=https&sig=l7GMFjTs1G5d9R52gxSUNKbqzhj1wiC2%2Be7lRrkp19k%3D'
    } else if (getEnvType() === "qa") {
        return 'sv=2024-11-04&ss=b&srt=o&sp=rtfx&se=2025-12-31T13:27:34Z&st=2025-07-02T05:27:34Z&spr=https&sig=KrN35V3mSjhTezkKqLo6LGRjZKLlERbXEYwRnC5ui2M%3D'
    }
    return 'sv=2022-11-02&ss=bf&srt=o&sp=r&se=2024-12-30T20:23:58Z&st=2024-08-13T12:23:58Z&spr=https,http&sig=RwUwkAi71F4xJdZhNMVeO67QcFbRgdx%2Fav2szOYIjyE%3D'
}

export function blobWriteString() {
    if (getEnvType() === "prod") {
        return blobNoCacheDomain() + '?sv=2024-11-04&ss=bf&srt=sco&sp=rwdlaciytfx&se=2026-12-31T14:23:05Z&st=2025-08-14T06:08:05Z&spr=https&sig=A0af1qT2uejyyb9bMAhGsT848%2FvBs%2FHuFetevaeWikc%3D'
    } else if (getEnvType() === "qa") {
        return blobNoCacheDomain() + '?sv=2024-11-04&ss=b&srt=o&sp=rwdactfx&se=2025-12-31T13:27:34Z&st=2025-07-02T05:27:34Z&spr=https&sig=eWgWE7%2B1%2FVRmX6%2F2%2F1LbNSIqZWeAshSjvZtei1KlA4A%3D'
    }
    return blobNoCacheDomain() + "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-12-30T20:16:39Z&st=2024-04-01T01:16:39Z&spr=https,http&sig=6VKWJm1Pett7HzmIz%2Fh7Q8%2FFR%2F6k1A8VMwuC7vAyu6s%3D"
}

export function handleCacheControl(url) {

    if (url.match(/\.wasm/) || url.match(/\.data/) || url.match(/\.bundle/)) {

        // return "must-revalidate";
        return 'immutable'

    }

    if (url.match(/\.mp4/) || url.match(/\.wav/)) {

        return "immutable";

    }

    return "no-store";

}

export function blobServiceClientFunc() {
    if (getEnvType() === "prod") {
        return blobServiceClientFuncForPROD()
    } else if (getEnvType() === "qa") {
        return blobServiceClientForDEV()
    } else {
        return blobServiceClientFuncForDev()
    }
}

// function blobServiceClientFuncForQA() {
//     const { BlobServiceClient } = require("@azure/storage-blob");
//     const { InteractiveBrowserCredential } = require("@azure/identity");
//     window.Buffer = require("buffer").Buffer;

//     const blobSasUrl = blobWriteString()

//     const blobServiceClient = new BlobServiceClient(blobSasUrl, new InteractiveBrowserCredential(
//         {
//             tenantId: "a04222fe-0c5c-40bb-8420-97a219ba514e",
//             clientId: "64073365-5a03-4736-b34e-597376266a0c"
//         }
//     ));
//     return blobServiceClient
// }

function blobServiceClientFuncForDev() {
    const { BlobServiceClient } = require("@azure/storage-blob");
    const { InteractiveBrowserCredential } = require("@azure/identity");
    window.Buffer = require("buffer").Buffer;

    const blobSasUrl = blobWriteString()

    const blobServiceClient = new BlobServiceClient(blobSasUrl, new InteractiveBrowserCredential(
        {
            tenantId: "a04222fe-0c5c-40bb-8420-97a219ba514e",
            clientId: "64073365-5a03-4736-b34e-597376266a0c"
        }
    ));
    return blobServiceClient
}

function blobServiceClientFuncForPROD() {
    const { BlobServiceClient } = require("@azure/storage-blob");
    window.Buffer = require("buffer").Buffer;

    const blobSasUrl = blobWriteString()

    const blobServiceClient = new BlobServiceClient(blobSasUrl);
    return blobServiceClient
}

export function blobServiceClientForDEV() {
    const { BlobServiceClient } = require("@azure/storage-blob");
    window.Buffer = require("buffer").Buffer;

    const blobSasUrl = blobWriteString()

    const blobServiceClient = new BlobServiceClient(blobSasUrl);
    return blobServiceClient
}